import React from "react";
import { Route } from "react-router";
import Subscriptions from "pages/subscriptions";
import AuthRoute from "helpers/authentication/authRoute";

const SubscriptionRoutes = () => (
    <Route
        path="/subscriptions"
        element={
            <AuthRoute>
                <Subscriptions />
            </AuthRoute>
        }
    />
    
);

export default SubscriptionRoutes;
